
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.14.0
 * Query Engine version: e9771e62de70f79a5e1c604a2d7c8e2a0a874b48
 */
Prisma.prismaVersion = {
  client: "5.14.0",
  engine: "e9771e62de70f79a5e1c604a2d7c8e2a0a874b48"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ResourcePermissionScalarFieldEnum = {
  id: 'id',
  resource: 'resource',
  create: 'create',
  read: 'read',
  update: 'update',
  delete: 'delete',
  roleId: 'roleId',
  userId: 'userId',
  siteId: 'siteId',
  serviceUserId: 'serviceUserId'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  siteId: 'siteId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  oid: 'oid',
  firstName: 'firstName',
  lastName: 'lastName',
  displayName: 'displayName',
  email: 'email',
  status: 'status',
  lastLogin: 'lastLogin',
  userSettingsId: 'userSettingsId',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserSettingsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  phoneNumber: 'phoneNumber',
  mobilePhoneNumber: 'mobilePhoneNumber',
  signatureTitle: 'signatureTitle',
  emailQuoteToCustomer: 'emailQuoteToCustomer',
  visualUserName: 'visualUserName',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ServiceUserScalarFieldEnum = {
  id: 'id',
  systemCode: 'systemCode',
  serviceIdentifier: 'serviceIdentifier',
  name: 'name',
  contactEmail: 'contactEmail',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ServiceUserAuthScalarFieldEnum = {
  identifier: 'identifier',
  description: 'description',
  salt: 'salt',
  keyHash: 'keyHash',
  serviceUserId: 'serviceUserId',
  expirationDate: 'expirationDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SiteScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  code: 'code',
  specialization: 'specialization',
  name: 'name',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  countryCode: 'countryCode',
  phone: 'phone',
  email: 'email',
  erpDB: 'erpDB',
  active: 'active',
  useConfigurator: 'useConfigurator',
  useImportLineItems: 'useImportLineItems',
  consolidateImportedLineItems: 'consolidateImportedLineItems',
  useQuoteWonLossStatus: 'useQuoteWonLossStatus',
  useEmailSending: 'useEmailSending',
  quoteBuilderVersion: 'quoteBuilderVersion',
  quoteIdPrefix: 'quoteIdPrefix',
  siteConfigId: 'siteConfigId',
  originalSource: 'originalSource',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  snapSiteConfigUuid: 'snapSiteConfigUuid'
};

exports.Prisma.SiteConfigScalarFieldEnum = {
  id: 'id',
  status: 'status',
  configEntityPriorities: 'configEntityPriorities',
  historicWorkOrderMaxMonthsOld: 'historicWorkOrderMaxMonthsOld',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SnapSiteConfigScalarFieldEnum = {
  uuid: 'uuid',
  defaultPartRequirementFixedCost: 'defaultPartRequirementFixedCost',
  quantityDisplayMagnitude: 'quantityDisplayMagnitude',
  decimalPlaces: 'decimalPlaces',
  daysUntilExpiration: 'daysUntilExpiration',
  daysUntilExpectedWin: 'daysUntilExpectedWin',
  leadTimeFormat: 'leadTimeFormat',
  defaultWonLossStatus: 'defaultWonLossStatus',
  partSpecTable: 'partSpecTable',
  partInsightsMaxDaysForRecent: 'partInsightsMaxDaysForRecent',
  partInsightsMaxDaysForInclusion: 'partInsightsMaxDaysForInclusion',
  partInsightsHighWinRate: 'partInsightsHighWinRate',
  partInsightsLeadTimeRangeLow: 'partInsightsLeadTimeRangeLow',
  partInsightsLeadTimeRangeHigh: 'partInsightsLeadTimeRangeHigh',
  partInsightsLeadTimeMaxDaysForInclusion: 'partInsightsLeadTimeMaxDaysForInclusion',
  partInsightsVisible: 'partInsightsVisible',
  duplicateQuoteVisible: 'duplicateQuoteVisible',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.PriceStrategyConfigScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  priceStrategyType: 'priceStrategyType',
  snapSiteConfigUuid: 'snapSiteConfigUuid',
  enabled: 'enabled',
  discountCode: 'discountCode',
  marketCode: 'marketCode',
  targetContributionMargin: 'targetContributionMargin',
  quantityRange: 'quantityRange',
  targetGrossMargin: 'targetGrossMargin',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.LeadTimeConfigScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  leadTimeType: 'leadTimeType',
  days: 'days',
  nasPartDays: 'nasPartDays',
  defaultDays: 'defaultDays',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  priceStrategyConfigUuid: 'priceStrategyConfigUuid'
};

exports.Prisma.PriceSegmentConfigScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  priceSegmentType: 'priceSegmentType',
  priceStrategyConfigUuid: 'priceStrategyConfigUuid',
  enabled: 'enabled',
  low: 'low',
  medium: 'medium',
  high: 'high',
  portalsAdjustment: 'portalsAdjustment',
  threshold: 'threshold',
  ltAdjustment: 'ltAdjustment',
  gteAdjustment: 'gteAdjustment',
  simple: 'simple',
  moderate: 'moderate',
  complex: 'complex',
  defaultAdjustment: 'defaultAdjustment',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.MarketIndustryAdjustmentScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  marketCode: 'marketCode',
  adjustment: 'adjustment',
  priceSegmentConfigUuid: 'priceSegmentConfigUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.LastTransactionAgeAdjustmentScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  ageInDays: 'ageInDays',
  adjustment: 'adjustment',
  priceSegmentConfigUuid: 'priceSegmentConfigUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.LastGrossMarginAdjustmentScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  margin: 'margin',
  adjustment: 'adjustment',
  priceSegmentConfigUuid: 'priceSegmentConfigUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.QuotingConfigScalarFieldEnum = {
  id: 'id',
  status: 'status',
  configEntityPriorities: 'configEntityPriorities',
  name: 'name',
  basisQtySrc: 'basisQtySrc',
  basisQtyDefault: 'basisQtyDefault',
  marketCodeDefault: 'marketCodeDefault',
  discountCodeDefault: 'discountCodeDefault',
  pricingConfigId: 'pricingConfigId',
  pricingConfigHistoryIds: 'pricingConfigHistoryIds',
  costingConfigId: 'costingConfigId',
  costingConfigHistoryIds: 'costingConfigHistoryIds',
  siteId: 'siteId',
  daysUntilExpiration: 'daysUntilExpiration',
  daysUntilExpectedWin: 'daysUntilExpectedWin',
  quantityDisplayMagnitude: 'quantityDisplayMagnitude',
  defaultWonLossStatus: 'defaultWonLossStatus',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CostingConfigScalarFieldEnum = {
  id: 'id',
  status: 'status',
  configEntityPriorities: 'configEntityPriorities',
  name: 'name',
  runHrsSrc: 'runHrsSrc',
  opBasisQtySrc: 'opBasisQtySrc',
  setupHrsSrc: 'setupHrsSrc',
  runRateSrc: 'runRateSrc',
  labRunCostPerHrSrc: 'labRunCostPerHrSrc',
  labRunCostPerUnitSrc: 'labRunCostPerUnitSrc',
  labSetupCostPerHrSrc: 'labSetupCostPerHrSrc',
  burRunCostPerHrSrc: 'burRunCostPerHrSrc',
  burRunCostPerUnitSrc: 'burRunCostPerUnitSrc',
  burSetupCostPerHrSrc: 'burSetupCostPerHrSrc',
  burCostPerOpSrc: 'burCostPerOpSrc',
  srvChargePerUnitSrc: 'srvChargePerUnitSrc',
  srvBaseChargeSrc: 'srvBaseChargeSrc',
  srvBaseChargeDefault: 'srvBaseChargeDefault',
  srvMinChargeSrc: 'srvMinChargeSrc',
  srvMinChargeDefault: 'srvMinChargeDefault',
  serviceIdSrc: 'serviceIdSrc',
  matMinCostSrc: 'matMinCostSrc',
  matMinCostDefault: 'matMinCostDefault',
  matFixedCostSrc: 'matFixedCostSrc',
  matUnitCostSrc: 'matUnitCostSrc',
  reqSrvUnitCostSrc: 'reqSrvUnitCostSrc',
  reqLabUnitCostSrc: 'reqLabUnitCostSrc',
  reqBurUnitCostSrc: 'reqBurUnitCostSrc',
  reqBurPctSrc: 'reqBurPctSrc',
  reqBurPerUnitSrc: 'reqBurPerUnitSrc',
  reqFixedQtySrc: 'reqFixedQtySrc',
  reqBasisQtySrc: 'reqBasisQtySrc',
  reqUnitsPerPieceSrc: 'reqUnitsPerPieceSrc',
  scrapFixedUnitsSrc: 'scrapFixedUnitsSrc',
  scrapYieldPercentSrc: 'scrapYieldPercentSrc',
  unitsPerPieceSrc: 'unitsPerPieceSrc',
  estLoadSizeQtySrc: 'estLoadSizeQtySrc',
  siteId: 'siteId',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PricingConfigScalarFieldEnum = {
  id: 'id',
  status: 'status',
  configEntityPriorities: 'configEntityPriorities',
  name: 'name',
  targetContrMarginPct: 'targetContrMarginPct',
  targetGrossMarginPct: 'targetGrossMarginPct',
  fixedPrice: 'fixedPrice',
  fixedPricingSrc: 'fixedPricingSrc',
  pricingStrategy: 'pricingStrategy',
  recalcPricingStrategy: 'recalcPricingStrategy',
  siteId: 'siteId',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomerScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  customerId: 'customerId',
  name: 'name',
  attentionName: 'attentionName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  countryCode: 'countryCode',
  phone: 'phone',
  email: 'email',
  billingName: 'billingName',
  billingAddress1: 'billingAddress1',
  billingAddress2: 'billingAddress2',
  billingCity: 'billingCity',
  billingState: 'billingState',
  billingPostalCode: 'billingPostalCode',
  billingCountryCode: 'billingCountryCode',
  industry: 'industry',
  salesRepId: 'salesRepId',
  termsId: 'termsId',
  termsNetType: 'termsNetType',
  termsNetDays: 'termsNetDays',
  termsDiscountType: 'termsDiscountType',
  termsDiscountDays: 'termsDiscountDays',
  termsDiscountPercent: 'termsDiscountPercent',
  termsDescription: 'termsDescription',
  companyId: 'companyId',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  discountCode: 'discountCode',
  marketCode: 'marketCode',
  originalSource: 'originalSource',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomerDiscountScalarFieldEnum = {
  id: 'id',
  discountCode: 'discountCode',
  description: 'description',
  discountPercent: 'discountPercent'
};

exports.Prisma.CustomerDiscountToSiteScalarFieldEnum = {
  customerDiscountId: 'customerDiscountId',
  siteId: 'siteId'
};

exports.Prisma.DiscountPriceScalarFieldEnum = {
  id: 'id',
  qtyBreak1: 'qtyBreak1',
  qtyBreak2: 'qtyBreak2',
  qtyBreak3: 'qtyBreak3',
  qtyBreak4: 'qtyBreak4',
  qtyBreak5: 'qtyBreak5',
  qtyBreak6: 'qtyBreak6',
  qtyBreak7: 'qtyBreak7',
  qtyBreak8: 'qtyBreak8',
  qtyBreak9: 'qtyBreak9',
  qtyBreak10: 'qtyBreak10',
  unitPrice1: 'unitPrice1',
  unitPrice2: 'unitPrice2',
  unitPrice3: 'unitPrice3',
  unitPrice4: 'unitPrice4',
  unitPrice5: 'unitPrice5',
  unitPrice6: 'unitPrice6',
  unitPrice7: 'unitPrice7',
  unitPrice8: 'unitPrice8',
  unitPrice9: 'unitPrice9',
  unitPrice10: 'unitPrice10',
  defaultUnitPrice: 'defaultUnitPrice',
  partId: 'partId',
  partOriginalSource: 'partOriginalSource',
  discountCode: 'discountCode',
  siteId: 'siteId'
};

exports.Prisma.MarketScalarFieldEnum = {
  id: 'id',
  marketCode: 'marketCode',
  description: 'description',
  currencyId: 'currencyId',
  marketRate: 'marketRate'
};

exports.Prisma.MarketToSiteScalarFieldEnum = {
  marketId: 'marketId',
  siteId: 'siteId'
};

exports.Prisma.MarketPriceScalarFieldEnum = {
  id: 'id',
  qtyBreak1: 'qtyBreak1',
  qtyBreak2: 'qtyBreak2',
  qtyBreak3: 'qtyBreak3',
  qtyBreak4: 'qtyBreak4',
  qtyBreak5: 'qtyBreak5',
  qtyBreak6: 'qtyBreak6',
  qtyBreak7: 'qtyBreak7',
  qtyBreak8: 'qtyBreak8',
  qtyBreak9: 'qtyBreak9',
  qtyBreak10: 'qtyBreak10',
  unitPrice1: 'unitPrice1',
  unitPrice2: 'unitPrice2',
  unitPrice3: 'unitPrice3',
  unitPrice4: 'unitPrice4',
  unitPrice5: 'unitPrice5',
  unitPrice6: 'unitPrice6',
  unitPrice7: 'unitPrice7',
  unitPrice8: 'unitPrice8',
  unitPrice9: 'unitPrice9',
  unitPrice10: 'unitPrice10',
  defaultUnitPrice: 'defaultUnitPrice',
  partId: 'partId',
  partOriginalSource: 'partOriginalSource',
  marketCode: 'marketCode'
};

exports.Prisma.CustomerContactScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  originalSource: 'originalSource',
  name: 'name',
  phone: 'phone',
  email: 'email',
  notes: 'notes',
  customerId: 'customerId',
  customerOriginalSource: 'customerOriginalSource',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ConfiguratorSnapshotScalarFieldEnum = {
  id: 'id',
  form: 'form',
  description: 'description',
  siteId: 'siteId',
  customerPartId: 'customerPartId',
  siteUuid: 'siteUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  configurationUuid: 'configurationUuid',
  snapshotVersion: 'snapshotVersion'
};

exports.Prisma.PartScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  partId: 'partId',
  description: 'description',
  type: 'type',
  material: 'material',
  diagramUris: 'diagramUris',
  status: 'status',
  commodityCode: 'commodityCode',
  missingInErp: 'missingInErp',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  originalSource: 'originalSource',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartSiteScalarFieldEnum = {
  id: 'id',
  status: 'status',
  unitPrice: 'unitPrice',
  planningLeadtime: 'planningLeadtime',
  partId: 'partId',
  partOriginalSource: 'partOriginalSource',
  siteCode: 'siteCode',
  originalSource: 'originalSource',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartAlternateScalarFieldEnum = {
  alternatePartId: 'alternatePartId',
  primary: 'primary',
  customerId: 'customerId',
  customerOriginalSource: 'customerOriginalSource',
  partId: 'partId',
  partOriginalSource: 'partOriginalSource',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NegotiatedPriceScalarFieldEnum = {
  id: 'id',
  alternatePartId: 'alternatePartId',
  defaultPrice: 'defaultPrice',
  qtyBreaks: 'qtyBreaks',
  effectiveDate: 'effectiveDate',
  expirationDate: 'expirationDate',
  customerId: 'customerId',
  customerOriginalSource: 'customerOriginalSource',
  partId: 'partId',
  partOriginalSource: 'partOriginalSource',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RootQuoteScalarFieldEnum = {
  uuid: 'uuid',
  quoteId: 'quoteId',
  quoteBuilderVersion: 'quoteBuilderVersion',
  siteUuid: 'siteUuid',
  visualQuoteUuid: 'visualQuoteUuid',
  snapQuoteUuid: 'snapQuoteUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.QuoteScalarFieldEnum = {
  id: 'id',
  quoteId: 'quoteId',
  status: 'status',
  startDate: 'startDate',
  expireDate: 'expireDate',
  dueDate: 'dueDate',
  wonLossDate: 'wonLossDate',
  expectedWinDate: 'expectedWinDate',
  notes: 'notes',
  internalNotes: 'internalNotes',
  customerHeader: 'customerHeader',
  customerQuoteId: 'customerQuoteId',
  wonLossStatus: 'wonLossStatus',
  customerId: 'customerId',
  customerOriginalSource: 'customerOriginalSource',
  salesRepId: 'salesRepId',
  salesRepName: 'salesRepName',
  salesRepEmail: 'salesRepEmail',
  salesRepPhone: 'salesRepPhone',
  csrOid: 'csrOid',
  csrName: 'csrName',
  csrEmail: 'csrEmail',
  siteId: 'siteId',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  originalSource: 'originalSource',
  createdById: 'createdById',
  createdByServiceId: 'createdByServiceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuoteLineScalarFieldEnum = {
  id: 'id',
  customerPartId: 'customerPartId',
  externalId: 'externalId',
  lineNumber: 'lineNumber',
  quantity: 'quantity',
  status: 'status',
  description: 'description',
  automatedUnitPrice: 'automatedUnitPrice',
  automatedMargin: 'automatedMargin',
  automatedQuantity: 'automatedQuantity',
  automatedLeadTime: 'automatedLeadTime',
  changeReason: 'changeReason',
  unitPrice: 'unitPrice',
  baseUnitPrice: 'baseUnitPrice',
  unitServiceCost: 'unitServiceCost',
  unitLaborCost: 'unitLaborCost',
  unitBurdenCost: 'unitBurdenCost',
  unitMaterialCost: 'unitMaterialCost',
  calculatedUnitCost: 'calculatedUnitCost',
  leadTime: 'leadTime',
  note: 'note',
  rafFinishCode: 'rafFinishCode',
  rafFinishDescription: 'rafFinishDescription',
  rafPatchLockCode: 'rafPatchLockCode',
  purchaseMaterialAmount: 'purchaseMaterialAmount',
  purchaseMaterialPercent: 'purchaseMaterialPercent',
  fabricatedMaterialAmount: 'fabricatedMaterialAmount',
  fabricatedMaterialPercent: 'fabricatedMaterialPercent',
  laborCostAmount: 'laborCostAmount',
  laborCostPercent: 'laborCostPercent',
  burdenCostAmount: 'burdenCostAmount',
  burdenCostPercent: 'burdenCostPercent',
  serviceCostAmount: 'serviceCostAmount',
  serviceCostPercent: 'serviceCostPercent',
  quoteId: 'quoteId',
  quoteOriginalSource: 'quoteOriginalSource',
  partId: 'partId',
  partOriginalSource: 'partOriginalSource',
  finishedPartId: 'finishedPartId',
  historicalOrderLineId: 'historicalOrderLineId',
  engineeringQuoteId: 'engineeringQuoteId',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  historicalWorkOrderId: 'historicalWorkOrderId',
  historicalWorkOrderHistoryIds: 'historicalWorkOrderHistoryIds',
  historicalMasterId: 'historicalMasterId',
  createdById: 'createdById',
  createdByServiceId: 'createdByServiceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuoteLineQuantityBreakScalarFieldEnum = {
  id: 'id',
  breakNumber: 'breakNumber',
  automatedUnitPrice: 'automatedUnitPrice',
  automatedMargin: 'automatedMargin',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  baseUnitPrice: 'baseUnitPrice',
  unitServiceCost: 'unitServiceCost',
  unitLaborCost: 'unitLaborCost',
  unitBurdenCost: 'unitBurdenCost',
  unitMaterialCost: 'unitMaterialCost',
  purchaseMaterialAmount: 'purchaseMaterialAmount',
  purchaseMaterialPercent: 'purchaseMaterialPercent',
  fabricatedMaterialAmount: 'fabricatedMaterialAmount',
  fabricatedMaterialPercent: 'fabricatedMaterialPercent',
  laborCostAmount: 'laborCostAmount',
  laborCostPercent: 'laborCostPercent',
  burdenCostAmount: 'burdenCostAmount',
  burdenCostPercent: 'burdenCostPercent',
  serviceCostAmount: 'serviceCostAmount',
  serviceCostPercent: 'serviceCostPercent',
  quoteLineId: 'quoteLineId',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuoteLinePartOptionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  groupName: 'groupName',
  weight: 'weight',
  suboptionName: 'suboptionName',
  metadata: 'metadata',
  quoteLineId: 'quoteLineId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  orderId: 'orderId',
  originalSource: 'originalSource',
  description: 'description',
  status: 'status',
  currency: 'currency',
  orderDate: 'orderDate',
  promiseDate: 'promiseDate',
  promiseDelDate: 'promiseDelDate',
  desiredShipDate: 'desiredShipDate',
  lastShippedDate: 'lastShippedDate',
  quoteId: 'quoteId',
  quoteOriginalSource: 'quoteOriginalSource',
  siteId: 'siteId',
  customerId: 'customerId',
  customerOriginalSource: 'customerOriginalSource',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OrderLineScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  lineNumber: 'lineNumber',
  orderQuantity: 'orderQuantity',
  unitPrice: 'unitPrice',
  sellingUM: 'sellingUM',
  leadTime: 'leadTime',
  desiredShipDate: 'desiredShipDate',
  promiseShipDate: 'promiseShipDate',
  promiseDelDate: 'promiseDelDate',
  lastShippedDate: 'lastShippedDate',
  firstShippedDate: 'firstShippedDate',
  status: 'status',
  quoteId: 'quoteId',
  quoteLineNumber: 'quoteLineNumber',
  quoteOriginalSource: 'quoteOriginalSource',
  orderId: 'orderId',
  orderOriginalSource: 'orderOriginalSource',
  partId: 'partId',
  partOriginalSource: 'partOriginalSource',
  hasCostData: 'hasCostData',
  invoicedQuantity: 'invoicedQuantity',
  totalBurdenCost: 'totalBurdenCost',
  totalInvoicedAmount: 'totalInvoicedAmount',
  totalLaborCost: 'totalLaborCost',
  totalMaterialCost: 'totalMaterialCost',
  totalServiceCost: 'totalServiceCost',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DocumentScalarFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  fileType: 'fileType',
  type: 'type',
  bucketPath: 'bucketPath',
  visualPath: 'visualPath',
  visualDocumentId: 'visualDocumentId',
  quoteLineId: 'quoteLineId',
  snapQuoteVersionUuid: 'snapQuoteVersionUuid',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  snapOperationUuid: 'snapOperationUuid',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuoteFeedbackReasonTypeScalarFieldEnum = {
  id: 'id',
  type: 'type',
  reason: 'reason'
};

exports.Prisma.QuoteFeedbackScalarFieldEnum = {
  id: 'id',
  type: 'type',
  reason: 'reason',
  reasonTypeId: 'reasonTypeId',
  comments: 'comments',
  quoteId: 'quoteId',
  quoteLineId: 'quoteLineId',
  qtyBreakId: 'qtyBreakId',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartEngineeringScalarFieldEnum = {
  id: 'id',
  type: 'type',
  baseId: 'baseId',
  lotId: 'lotId',
  splitId: 'splitId',
  subId: 'subId',
  status: 'status',
  desiredQuantity: 'desiredQuantity',
  receivedQuantity: 'receivedQuantity',
  drawing: 'drawing',
  drawingRevision: 'drawingRevision',
  estimatedMaterialCost: 'estimatedMaterialCost',
  estimatedLaborCost: 'estimatedLaborCost',
  estimatedBurdenCost: 'estimatedBurdenCost',
  estimatedServiceCost: 'estimatedServiceCost',
  actualMaterialCost: 'actualMaterialCost',
  actualLaborCost: 'actualLaborCost',
  actualBurdenCost: 'actualBurdenCost',
  actualServiceCost: 'actualServiceCost',
  closeDate: 'closeDate',
  costedDate: 'costedDate',
  engineeredDate: 'engineeredDate',
  originalSource: 'originalSource',
  partId: 'partId',
  partOriginalSource: 'partOriginalSource',
  siteId: 'siteId',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartEngineeringOperationScalarFieldEnum = {
  id: 'id',
  engType: 'engType',
  engStatus: 'engStatus',
  baseId: 'baseId',
  lotId: 'lotId',
  splitId: 'splitId',
  subId: 'subId',
  sequenceNum: 'sequenceNum',
  resourceId: 'resourceId',
  runRate: 'runRate',
  runRateType: 'runRateType',
  qtyPerLineQty: 'qtyPerLineQty',
  runHrsPerLineQty: 'runHrsPerLineQty',
  qtyPerRunHr: 'qtyPerRunHr',
  estLoadSizeQty: 'estLoadSizeQty',
  estStartQty: 'estStartQty',
  estEndQty: 'estEndQty',
  actCompletedQty: 'actCompletedQty',
  estSetupHrs: 'estSetupHrs',
  estRunHrs: 'estRunHrs',
  actSetupHrs: 'actSetupHrs',
  actRunHrs: 'actRunHrs',
  estLabSetupCostPerHr: 'estLabSetupCostPerHr',
  estLabRunCostPerHr: 'estLabRunCostPerHr',
  estRunCostPerUnit: 'estRunCostPerUnit',
  estBurRunCostPerHr: 'estBurRunCostPerHr',
  estBurSetupCostPerHr: 'estBurSetupCostPerHr',
  estBurRunCostPerUnit: 'estBurRunCostPerUnit',
  estBurPctSetup: 'estBurPctSetup',
  estBurPctRun: 'estBurPctRun',
  estBurPerOperation: 'estBurPerOperation',
  actLabSetupCostPerHr: 'actLabSetupCostPerHr',
  actLabRunCostPerHr: 'actLabRunCostPerHr',
  actBurSetupCostPerHr: 'actBurSetupCostPerHr',
  actBurRunCostPerHr: 'actBurRunCostPerHr',
  estAtlLabTotal: 'estAtlLabTotal',
  estAtlBurTotal: 'estAtlBurTotal',
  estAtlSrvTotal: 'estAtlSrvTotal',
  estReqMatTotal: 'estReqMatTotal',
  estReqLabTotal: 'estReqLabTotal',
  estReqBurTotal: 'estReqBurTotal',
  estReqSrvTotal: 'estReqSrvTotal',
  actAtlLabTotal: 'actAtlLabTotal',
  actAtlBurTotal: 'actAtlBurTotal',
  actAtlSrvTotal: 'actAtlSrvTotal',
  actReqMatTotal: 'actReqMatTotal',
  actReqLabTotal: 'actReqLabTotal',
  actReqBurTotal: 'actReqBurTotal',
  actReqSrvTotal: 'actReqSrvTotal',
  serviceId: 'serviceId',
  estSrvBaseCharge: 'estSrvBaseCharge',
  estSrvMinCharge: 'estSrvMinCharge',
  scrapFixedUnits: 'scrapFixedUnits',
  scrapYieldType: 'scrapYieldType',
  scrapYieldPercent: 'scrapYieldPercent',
  servicePartId: 'servicePartId',
  originalSource: 'originalSource',
  siteId: 'siteId',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartEngineeringRequirementScalarFieldEnum = {
  id: 'id',
  engType: 'engType',
  engStatus: 'engStatus',
  baseId: 'baseId',
  lotId: 'lotId',
  splitId: 'splitId',
  subId: 'subId',
  sequenceNum: 'sequenceNum',
  pieceNum: 'pieceNum',
  unitsPerPiece: 'unitsPerPiece',
  unitsPerPieceType: 'unitsPerPieceType',
  scrapPercent: 'scrapPercent',
  estUnitsPerOpQty: 'estUnitsPerOpQty',
  estUnitsPerLineQty: 'estUnitsPerLineQty',
  minMtrlCost: 'minMtrlCost',
  usageUM: 'usageUM',
  estQty: 'estQty',
  actQty: 'actQty',
  estFixedQty: 'estFixedQty',
  estMatFixedCost: 'estMatFixedCost',
  estUnitMatCost: 'estUnitMatCost',
  estUnitLabCost: 'estUnitLabCost',
  estUnitBurCost: 'estUnitBurCost',
  estBurPct: 'estBurPct',
  estBurPerUnit: 'estBurPerUnit',
  estUnitSrvCost: 'estUnitSrvCost',
  estMatCostTotal: 'estMatCostTotal',
  estLabCostTotal: 'estLabCostTotal',
  estBurCostTotal: 'estBurCostTotal',
  estSrvCostTotal: 'estSrvCostTotal',
  actMatCostTotal: 'actMatCostTotal',
  actLabCostTotal: 'actLabCostTotal',
  actBurCostTotal: 'actBurCostTotal',
  actSrvCostTotal: 'actSrvCostTotal',
  originalSource: 'originalSource',
  reqPartId: 'reqPartId',
  reqPartOriginalSource: 'reqPartOriginalSource',
  siteId: 'siteId',
  quotingConfigId: 'quotingConfigId',
  quotingConfigHistoryIds: 'quotingConfigHistoryIds',
  createdById: 'createdById',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ETLUpdatesScalarFieldEnum = {
  id: 'id',
  lastPartsUpdate: 'lastPartsUpdate',
  lastCustomerUpdate: 'lastCustomerUpdate',
  createdAt: 'createdAt'
};

exports.Prisma.SnapQuoteScalarFieldEnum = {
  uuid: 'uuid',
  status: 'status',
  quoteId: 'quoteId',
  customerUuid: 'customerUuid',
  siteUuid: 'siteUuid',
  createdByUserUuid: 'createdByUserUuid',
  deletedByUserUuid: 'deletedByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  currentVersionUuid: 'currentVersionUuid',
  copiedFromUuid: 'copiedFromUuid'
};

exports.Prisma.SnapQuoteVersionScalarFieldEnum = {
  uuid: 'uuid',
  sentAt: 'sentAt',
  name: 'name',
  address1: 'address1',
  address2: 'address2',
  address3: 'address3',
  state: 'state',
  city: 'city',
  country: 'country',
  zipcode: 'zipcode',
  contactName: 'contactName',
  contactPhone: 'contactPhone',
  contactEmail: 'contactEmail',
  salesRepId: 'salesRepId',
  salesRepName: 'salesRepName',
  salesRepEmail: 'salesRepEmail',
  salesRepPhone: 'salesRepPhone',
  csrOid: 'csrOid',
  csrName: 'csrName',
  csrEmail: 'csrEmail',
  daysUntilQuoteExpires: 'daysUntilQuoteExpires',
  daysUntilExpectedWin: 'daysUntilExpectedWin',
  specs: 'specs',
  notes: 'notes',
  wonLossStatus: 'wonLossStatus',
  discountCode: 'discountCode',
  marketCode: 'marketCode',
  customerQuoteId: 'customerQuoteId',
  createdByUserUuid: 'createdByUserUuid',
  deletedByUserUuid: 'deletedByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  snapQuoteUuid: 'snapQuoteUuid'
};

exports.Prisma.SnapQuoteLineScalarFieldEnum = {
  uuid: 'uuid',
  lineNumber: 'lineNumber',
  specs: 'specs',
  priceStrategy: 'priceStrategy',
  leadTime: 'leadTime',
  leadTimeNotes: 'leadTimeNotes',
  automatedLeadTime: 'automatedLeadTime',
  userLeadTime: 'userLeadTime',
  snapQuoteVersionUuid: 'snapQuoteVersionUuid',
  partUuid: 'partUuid',
  customerPartId: 'customerPartId',
  finishedPartId: 'finishedPartId',
  snapWorkOrderUuid: 'snapWorkOrderUuid',
  initialMarginSource: 'initialMarginSource',
  lastWinOrderLineId: 'lastWinOrderLineId',
  leadTimeSuggestionStatus: 'leadTimeSuggestionStatus',
  suggestedPricesStatus: 'suggestedPricesStatus',
  automatable: 'automatable',
  priceAdjustment: 'priceAdjustment',
  priceAdjustmentAmount: 'priceAdjustmentAmount',
  productOptionsChangeUnitPrice: 'productOptionsChangeUnitPrice',
  configuratorSnapshotUuid: 'configuratorSnapshotUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  snapQuoteLineSource: 'snapQuoteLineSource'
};

exports.Prisma.SnapQuotePriceScalarFieldEnum = {
  uuid: 'uuid',
  priceStrategy: 'priceStrategy',
  priceCalculationResults: 'priceCalculationResults',
  suggestedPriceStatus: 'suggestedPriceStatus',
  quantity: 'quantity',
  automatedQuantity: 'automatedQuantity',
  userQuantity: 'userQuantity',
  unitPrice: 'unitPrice',
  automatedUnitPrice: 'automatedUnitPrice',
  calculatedUnitPrice: 'calculatedUnitPrice',
  userUnitPrice: 'userUnitPrice',
  totalPrice: 'totalPrice',
  automatedUnitCost: 'automatedUnitCost',
  calculatedUnitCost: 'calculatedUnitCost',
  unitCost: 'unitCost',
  userUnitCost: 'userUnitCost',
  unitBurdenCost: 'unitBurdenCost',
  unitLaborCost: 'unitLaborCost',
  unitMaterialCost: 'unitMaterialCost',
  unitServiceCost: 'unitServiceCost',
  automatedGrossMargin: 'automatedGrossMargin',
  calculatedGrossMargin: 'calculatedGrossMargin',
  grossMargin: 'grossMargin',
  userGrossMargin: 'userGrossMargin',
  automatedBaseGrossMargin: 'automatedBaseGrossMargin',
  baseGrossMargin: 'baseGrossMargin',
  calculatedBaseGrossMargin: 'calculatedBaseGrossMargin',
  baseUnitPrice: 'baseUnitPrice',
  priceAdjustmentAmount: 'priceAdjustmentAmount',
  unitVariableCosts: 'unitVariableCosts',
  automatedContributionMargin: 'automatedContributionMargin',
  calculatedContributionMargin: 'calculatedContributionMargin',
  contributionMargin: 'contributionMargin',
  userContributionMargin: 'userContributionMargin',
  unitPriceAddition: 'unitPriceAddition',
  changesUnitPrice: 'changesUnitPrice',
  discountCode: 'discountCode',
  marketCode: 'marketCode',
  purchaseMaterialAmount: 'purchaseMaterialAmount',
  purchaseMaterialPercent: 'purchaseMaterialPercent',
  fabricatedMaterialAmount: 'fabricatedMaterialAmount',
  fabricatedMaterialPercent: 'fabricatedMaterialPercent',
  laborCostAmount: 'laborCostAmount',
  laborCostPercent: 'laborCostPercent',
  burdenCostAmount: 'burdenCostAmount',
  burdenCostPercent: 'burdenCostPercent',
  serviceCostAmount: 'serviceCostAmount',
  serviceCostPercent: 'serviceCostPercent',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SnapWorkOrderScalarFieldEnum = {
  uuid: 'uuid',
  drawingId: 'drawingId',
  drawingRevisionNo: 'drawingRevisionNo',
  originalWorkOrderUuid: 'originalWorkOrderUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SnapOperationScalarFieldEnum = {
  uuid: 'uuid',
  sequenceNo: 'sequenceNo',
  resourceId: 'resourceId',
  run: 'run',
  runType: 'runType',
  loadSizeQty: 'loadSizeQty',
  setupHrs: 'setupHrs',
  setupCostPerHr: 'setupCostPerHr',
  runCostPerHr: 'runCostPerHr',
  runCostPerUnit: 'runCostPerUnit',
  serviceBaseCharge: 'serviceBaseCharge',
  serviceMinCharge: 'serviceMinCharge',
  serviceChargePerUnit: 'serviceChargePerUnit',
  serviceId: 'serviceId',
  burPerHrSetup: 'burPerHrSetup',
  burPerHrRun: 'burPerHrRun',
  burPerUnitRun: 'burPerUnitRun',
  burPercentRun: 'burPercentRun',
  burPercentSetup: 'burPercentSetup',
  scrapYieldPct: 'scrapYieldPct',
  scrapYieldType: 'scrapYieldType',
  fixedScrapUnits: 'fixedScrapUnits',
  originalOperationUuid: 'originalOperationUuid',
  snapWorkOrderUuid: 'snapWorkOrderUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SnapRequirementScalarFieldEnum = {
  uuid: 'uuid',
  pieceNo: 'pieceNo',
  calcQty: 'calcQty',
  qtyPer: 'qtyPer',
  qtyPerType: 'qtyPerType',
  fixedQty: 'fixedQty',
  unitMaterialCost: 'unitMaterialCost',
  unitLaborCost: 'unitLaborCost',
  unitBurdenCost: 'unitBurdenCost',
  unitServiceCost: 'unitServiceCost',
  fixedCost: 'fixedCost',
  scrapPercent: 'scrapPercent',
  partUuid: 'partUuid',
  originalRequirementUuid: 'originalRequirementUuid',
  snapOperationUuid: 'snapOperationUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PriceSegmentScalarFieldEnum = {
  uuid: 'uuid',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  segment: 'segment',
  matched: 'matched',
  priceAdjustment: 'priceAdjustment',
  resultsMetadata: 'resultsMetadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SnapProductOptionScalarFieldEnum = {
  uuid: 'uuid',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  code: 'code',
  groupName: 'groupName',
  optionName: 'optionName',
  subOptionName: 'subOptionName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.ResourceEnum = exports.$Enums.ResourceEnum = {
  QUOTE: 'QUOTE',
  USER: 'USER',
  SITE: 'SITE',
  CUSTOMER: 'CUSTOMER',
  METRICS: 'METRICS',
  ADMIN: 'ADMIN',
  ADMIN_QUOTING: 'ADMIN_QUOTING',
  ADMIN_USERS: 'ADMIN_USERS',
  ADMIN_SITE: 'ADMIN_SITE',
  ADMIN_METRICS: 'ADMIN_METRICS',
  ALPHA: 'ALPHA',
  BETA: 'BETA',
  DEVELOPER: 'DEVELOPER',
  SUPERADMIN: 'SUPERADMIN'
};

exports.UserStatus = exports.$Enums.UserStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  DISABLED: 'DISABLED'
};

exports.ERPDB = exports.$Enums.ERPDB = {
  VISUAL: 'VISUAL',
  VISUALSPR: 'VISUALSPR',
  VISUALFAS: 'VISUALFAS',
  EPICOR: 'EPICOR'
};

exports.QuoteBuilderVersion = exports.$Enums.QuoteBuilderVersion = {
  V1: 'V1',
  V2: 'V2'
};

exports.OriginalSource = exports.$Enums.OriginalSource = {
  DWH_STG_VIS: 'DWH_STG_VIS',
  DWH_STG_MWIFAS: 'DWH_STG_MWIFAS',
  SNAP: 'SNAP'
};

exports.ConfigStatus = exports.$Enums.ConfigStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

exports.ConfigEntities = exports.$Enums.ConfigEntities = {
  SITE: 'SITE',
  USER: 'USER',
  CUSTOMER: 'CUSTOMER',
  PART: 'PART',
  QUOTE: 'QUOTE',
  QUOTE_LINE: 'QUOTE_LINE',
  QTY_BRK: 'QTY_BRK',
  REQ_PART: 'REQ_PART'
};

exports.DisplayMagnitude = exports.$Enums.DisplayMagnitude = {
  ONES: 'ONES',
  THOUSANDS: 'THOUSANDS'
};

exports.LeadTimeFormat = exports.$Enums.LeadTimeFormat = {
  BOTH: 'BOTH',
  NUMBER: 'NUMBER',
  TEXT: 'TEXT'
};

exports.WonLossStatus = exports.$Enums.WonLossStatus = {
  COMPLETED: 'COMPLETED',
  CONVERTED: 'CONVERTED',
  LOSS_CAPABILITIES: 'LOSS_CAPABILITIES',
  LOSS_CAPABILITIES_NO_QUOTE: 'LOSS_CAPABILITIES_NO_QUOTE',
  LOSS_CUSTOMER_LOST_BID: 'LOSS_CUSTOMER_LOST_BID',
  LOSS_EXCEPTIONS_NOT_ACCEPTED: 'LOSS_EXCEPTIONS_NOT_ACCEPTED',
  LOSS_LACKING_CERTIFICATION: 'LOSS_LACKING_CERTIFICATION',
  LOSS_LEAD_TIME: 'LOSS_LEAD_TIME',
  LOSS_PRICE: 'LOSS_PRICE',
  LOSS_QUOTING_FOR_MULTIPLE_CUSTOMERS: 'LOSS_QUOTING_FOR_MULTIPLE_CUSTOMERS',
  LOSS_QUOTING_FOR_MULTIPLE_REVS_PART_ITERATIONS: 'LOSS_QUOTING_FOR_MULTIPLE_REVS_PART_ITERATIONS',
  LOSS_ROUTINE_COMPETITIVE_CHECK: 'LOSS_ROUTINE_COMPETITIVE_CHECK',
  LOSS_TERMS_OF_SALE: 'LOSS_TERMS_OF_SALE',
  LOSS_QUOTE_NOT_FAST_ENOUGH: 'LOSS_QUOTE_NOT_FAST_ENOUGH',
  LOSS_PROJECT_CANCELLED: 'LOSS_PROJECT_CANCELLED',
  PAUSED: 'PAUSED',
  PENDING_CUSTOMER_RESPONSE: 'PENDING_CUSTOMER_RESPONSE',
  PENDING_MANUFACTURING: 'PENDING_MANUFACTURING',
  PENDING_OUTSIDE_PROCESS: 'PENDING_OUTSIDE_PROCESS',
  PENDING_REVISED_PO_CONTRACT_REVIEW: 'PENDING_REVISED_PO_CONTRACT_REVIEW',
  PENDING_REVISED_PO_PRICE: 'PENDING_REVISED_PO_PRICE',
  PENDING_BUYOUT_PRICE: 'PENDING_BUYOUT_PRICE',
  QUOTED: 'QUOTED',
  RFQ_RECEIVED: 'RFQ_RECEIVED',
  WIN_CAPABILITIES: 'WIN_CAPABILITIES',
  WIN_LEAD_TIME: 'WIN_LEAD_TIME',
  WIN_PRICE: 'WIN_PRICE'
};

exports.PartSpecTable = exports.$Enums.PartSpecTable = {
  PART_BINARY: 'PART_BINARY',
  PART_CO_BINARY: 'PART_CO_BINARY'
};

exports.FeatureVisibility = exports.$Enums.FeatureVisibility = {
  NONE: 'NONE',
  SUPER_ADMIN: 'SUPER_ADMIN',
  ALL: 'ALL'
};

exports.PriceStrategy = exports.$Enums.PriceStrategy = {
  CAPPriceSegmentation: 'CAPPriceSegmentation',
  FixedCustomer: 'FixedCustomer',
  FixedDefault: 'FixedDefault',
  FixedDiscount: 'FixedDiscount',
  FixedMarket: 'FixedMarket',
  UserImport: 'UserImport',
  PriceSegmentation: 'PriceSegmentation',
  TargetGrossMargin: 'TargetGrossMargin',
  TargetContributionMargin: 'TargetContributionMargin',
  UserPrice: 'UserPrice',
  NewPartUserPrice: 'NewPartUserPrice',
  NewPartUserCost: 'NewPartUserCost',
  RAFFixedMarket: 'RAFFixedMarket',
  RAFTargetGrossMargin: 'RAFTargetGrossMargin',
  NewPart: 'NewPart'
};

exports.LeadTimeConfigType = exports.$Enums.LeadTimeConfigType = {
  PLANNING_LEADTIME: 'PLANNING_LEADTIME',
  CONSTANT_VALUE: 'CONSTANT_VALUE',
  RAF_FIXED_MARKET: 'RAF_FIXED_MARKET'
};

exports.PriceSegmentType = exports.$Enums.PriceSegmentType = {
  CustomerPotential: 'CustomerPotential',
  CustomerPortals: 'CustomerPortals',
  ProductOperationsCount: 'ProductOperationsCount',
  ProductComplexity: 'ProductComplexity',
  MarketIndustry: 'MarketIndustry',
  LastTransactionAge: 'LastTransactionAge',
  LastGrossMargin: 'LastGrossMargin'
};

exports.QtyBasisSources = exports.$Enums.QtyBasisSources = {
  LAST_ORDER: 'LAST_ORDER',
  HIST_WORK_ORDER_ACT: 'HIST_WORK_ORDER_ACT',
  HIST_WORK_ORDER_EST: 'HIST_WORK_ORDER_EST',
  MASTER_EST: 'MASTER_EST',
  FIXED_PRICING: 'FIXED_PRICING',
  LAST_QUOTE: 'LAST_QUOTE',
  CONFIG_DEFAULT: 'CONFIG_DEFAULT'
};

exports.CostInputSources = exports.$Enums.CostInputSources = {
  HIST_WORK_ORDER_ACT: 'HIST_WORK_ORDER_ACT',
  HIST_WORK_ORDER_EST: 'HIST_WORK_ORDER_EST',
  MASTER_EST: 'MASTER_EST',
  MANUAL_ENTRY: 'MANUAL_ENTRY',
  CONFIG_DEFAULT: 'CONFIG_DEFAULT'
};

exports.FixedPricingSources = exports.$Enums.FixedPricingSources = {
  CustomerPricing: 'CustomerPricing',
  MarketPricing: 'MarketPricing',
  DiscountPricing: 'DiscountPricing',
  NegotiatedPricing: 'NegotiatedPricing'
};

exports.PricingStrategy = exports.$Enums.PricingStrategy = {
  TARGET_CONTR_MARGIN: 'TARGET_CONTR_MARGIN',
  TARGET_GROSS_MARGIN: 'TARGET_GROSS_MARGIN',
  FIXED: 'FIXED',
  RAF_CUSTOM: 'RAF_CUSTOM'
};

exports.ConfiguratorSnapshotVersion = exports.$Enums.ConfiguratorSnapshotVersion = {
  V1: 'V1',
  V2: 'V2'
};

exports.PartStatus = exports.$Enums.PartStatus = {
  A: 'A',
  I: 'I',
  O: 'O'
};

exports.QuoteStatus = exports.$Enums.QuoteStatus = {
  NEW: 'NEW',
  INPROGRESS: 'INPROGRESS',
  SENT: 'SENT',
  WON: 'WON',
  LOSS: 'LOSS',
  DELETED: 'DELETED',
  CANCELLED: 'CANCELLED',
  INHOUSE: 'INHOUSE',
  READY: 'READY',
  TEST: 'TEST'
};

exports.QuoteLineStatus = exports.$Enums.QuoteLineStatus = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED'
};

exports.OrderStatus = exports.$Enums.OrderStatus = {
  C: 'C',
  X: 'X',
  R: 'R',
  H: 'H',
  F: 'F'
};

exports.OrderLineStatus = exports.$Enums.OrderLineStatus = {
  A: 'A',
  C: 'C'
};

exports.DocumentType = exports.$Enums.DocumentType = {
  MASTER_QUOTE: 'MASTER_QUOTE',
  QUOTE_DOCUMENT: 'QUOTE_DOCUMENT',
  OPERATION_DOCUMENT: 'OPERATION_DOCUMENT'
};

exports.FeedbackType = exports.$Enums.FeedbackType = {
  RECOMMENDED_PRICE_CHANGE: 'RECOMMENDED_PRICE_CHANGE',
  RECOMMENDED_QUANTITY_CHANGE: 'RECOMMENDED_QUANTITY_CHANGE',
  RECOMMENDED_LEAD_TIME_CHANGE: 'RECOMMENDED_LEAD_TIME_CHANGE'
};

exports.QuoteFeedbackReason = exports.$Enums.QuoteFeedbackReason = {
  COST_VARIANCES: 'COST_VARIANCES',
  AGGRESSIVE_PRICING: 'AGGRESSIVE_PRICING',
  INDUSTRY_MARKET_SEGMENTATION: 'INDUSTRY_MARKET_SEGMENTATION',
  OTHER: 'OTHER'
};

exports.PartEngineeringType = exports.$Enums.PartEngineeringType = {
  QUOTE: 'QUOTE',
  ENGINEERING_MASTER: 'ENGINEERING_MASTER',
  WORK_ORDER: 'WORK_ORDER'
};

exports.PartEngineeringStatus = exports.$Enums.PartEngineeringStatus = {
  CLOSED: 'CLOSED',
  FIRMED: 'FIRMED',
  RELEASED: 'RELEASED',
  UNRELEASED: 'UNRELEASED',
  CANCELLED: 'CANCELLED'
};

exports.RunRateType = exports.$Enums.RunRateType = {
  PCS_PER_HR: 'PCS_PER_HR',
  HRS_PER_PC: 'HRS_PER_PC',
  MIN_PER_PC: 'MIN_PER_PC',
  DAYS_PER_PC: 'DAYS_PER_PC',
  HRS_PER_LOAD: 'HRS_PER_LOAD',
  DAYS_PER_LOAD: 'DAYS_PER_LOAD',
  PCS_PER_MIN: 'PCS_PER_MIN',
  PCS_PER_DAY: 'PCS_PER_DAY',
  LOADS_PER_HR: 'LOADS_PER_HR',
  LOADS_PER_DAY: 'LOADS_PER_DAY'
};

exports.ScrapYieldType = exports.$Enums.ScrapYieldType = {
  SCRAP: 'SCRAP',
  YIELD: 'YIELD'
};

exports.UnitsPerPieceType = exports.$Enums.UnitsPerPieceType = {
  START: 'START',
  END: 'END'
};

exports.SnapQuoteStatus = exports.$Enums.SnapQuoteStatus = {
  NEW: 'NEW',
  INPROGRESS: 'INPROGRESS',
  SENT: 'SENT',
  DELETED: 'DELETED'
};

exports.InitialMarginSource = exports.$Enums.InitialMarginSource = {
  lastWin: 'lastWin',
  targetContributionMargin: 'targetContributionMargin',
  targetGrossMargin: 'targetGrossMargin',
  calculatedFromLastWinUnitPrice: 'calculatedFromLastWinUnitPrice'
};

exports.SnapSuggestionStatus = exports.$Enums.SnapSuggestionStatus = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  EXCLUDED: 'EXCLUDED',
  UNKNOWN: 'UNKNOWN'
};

exports.SnapQuoteLineSource = exports.$Enums.SnapQuoteLineSource = {
  PART_PICKER: 'PART_PICKER',
  IMPORT: 'IMPORT',
  CONFIGURATOR: 'CONFIGURATOR'
};

exports.QtyPerType = exports.$Enums.QtyPerType = {
  START: 'START',
  END: 'END'
};

exports.Prisma.ModelName = {
  ResourcePermission: 'ResourcePermission',
  Role: 'Role',
  User: 'User',
  UserSettings: 'UserSettings',
  ServiceUser: 'ServiceUser',
  ServiceUserAuth: 'ServiceUserAuth',
  Site: 'Site',
  SiteConfig: 'SiteConfig',
  SnapSiteConfig: 'SnapSiteConfig',
  PriceStrategyConfig: 'PriceStrategyConfig',
  LeadTimeConfig: 'LeadTimeConfig',
  PriceSegmentConfig: 'PriceSegmentConfig',
  MarketIndustryAdjustment: 'MarketIndustryAdjustment',
  LastTransactionAgeAdjustment: 'LastTransactionAgeAdjustment',
  LastGrossMarginAdjustment: 'LastGrossMarginAdjustment',
  QuotingConfig: 'QuotingConfig',
  CostingConfig: 'CostingConfig',
  PricingConfig: 'PricingConfig',
  Customer: 'Customer',
  CustomerDiscount: 'CustomerDiscount',
  CustomerDiscountToSite: 'CustomerDiscountToSite',
  DiscountPrice: 'DiscountPrice',
  Market: 'Market',
  MarketToSite: 'MarketToSite',
  MarketPrice: 'MarketPrice',
  CustomerContact: 'CustomerContact',
  ConfiguratorSnapshot: 'ConfiguratorSnapshot',
  Part: 'Part',
  PartSite: 'PartSite',
  PartAlternate: 'PartAlternate',
  NegotiatedPrice: 'NegotiatedPrice',
  RootQuote: 'RootQuote',
  Quote: 'Quote',
  QuoteLine: 'QuoteLine',
  QuoteLineQuantityBreak: 'QuoteLineQuantityBreak',
  QuoteLinePartOption: 'QuoteLinePartOption',
  Order: 'Order',
  OrderLine: 'OrderLine',
  Document: 'Document',
  QuoteFeedbackReasonType: 'QuoteFeedbackReasonType',
  QuoteFeedback: 'QuoteFeedback',
  PartEngineering: 'PartEngineering',
  PartEngineeringOperation: 'PartEngineeringOperation',
  PartEngineeringRequirement: 'PartEngineeringRequirement',
  ETLUpdates: 'ETLUpdates',
  SnapQuote: 'SnapQuote',
  SnapQuoteVersion: 'SnapQuoteVersion',
  SnapQuoteLine: 'SnapQuoteLine',
  SnapQuotePrice: 'SnapQuotePrice',
  SnapWorkOrder: 'SnapWorkOrder',
  SnapOperation: 'SnapOperation',
  SnapRequirement: 'SnapRequirement',
  PriceSegment: 'PriceSegment',
  SnapProductOption: 'SnapProductOption'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
